import React from 'react';
import {
  getArenaName,
  getNiceDayAndDateForMatchlist,
} from '../../utils/matches';
import { getMatchUrl } from '../../utils/routes';

function MatchRowFinished({ match }) {
  const {
    homeTeamName,
    visitingTeamName,
    homeTeamScore,
    visitingTeamScore,
    startDate,
  } = match;

  return (
    <div className="col-12 px-4 py-2 data-container__row data-container__row--has-hover">
      <div className="row">
        <div className="col-8 col-md">
          <p className="heading-h6 mb-1 text-color-comp-gray-1">
            {getNiceDayAndDateForMatchlist(startDate)}
          </p>
          <a
            href={getMatchUrl(
              match.configSeasonStartYear,
              match.id,
              homeTeamName,
              visitingTeamName
            )}
            className="heading-h5 text-transform-none text-decoration-none text-color-primary-white"
          >
            {homeTeamName} - {visitingTeamName}
          </a>
        </div>
        <div className="col-4 col-md d-flex justify-content-center flex-column align-items-end align-items-md-center">
          <p className="heading-h6 mb-1 text-color-comp-gray-1">
            {getArenaName(match)}
          </p>
          <div className="d-flex gap-1">
            <span className="score-result">{homeTeamScore}</span>
            <span className="score-result">{visitingTeamScore}</span>
          </div>
        </div>
        <div className="col d-none d-md-flex align-items-center justify-content-md-end">
          <a
            className="button button--primary-blue"
            href={getMatchUrl(
              match.configSeasonStartYear,
              match.id,
              homeTeamName,
              visitingTeamName
            )}
          >
            Summering
          </a>
        </div>
      </div>
    </div>
  );
}

export default MatchRowFinished;
